// extracted by mini-css-extract-plugin
export default {"root":"QuestionItem_root__UJ8EN","content":"QuestionItem_content__BfU8m","icon":"QuestionItem_icon__V8im6"};